import {
    createSlice,
    createAsyncThunk,
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const buildingsAdapter = createEntityAdapter({
    sortComparer: (a, b) => b.building_code.localeCompare(a.building_code),
})

const initalState = buildingsAdapter.getInitialState({
    status: 'idle',
    error: null,
})

// Fetch API for building list and singular building
export const fetchBuildings = createAsyncThunk(
    'buildings/fetchBuildings',
    async (args, {rejectWithValue}) => {
        return await axios.get(API.BUILDINGS_API)
            .then(response => response.data)
            .catch((error) => {
                return rejectWithValue(error.response.data)
            })
    }
)


const buildingsSlice = createSlice({
    name: 'buildings',
    initialState: initalState,
    reducers: {
    
    },
    extraReducers: {
        [fetchBuildings.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchBuildings.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            buildingsAdapter.setAll(state, action.payload)
        },
        [fetchBuildings.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload

            // //When Rejected, Prompt Message and redirect to login
            // window.confirm(state.error.detail)
            
        }
    }
})

export default buildingsSlice.reducer

export const {
    selectAll: selectAllBuildings,
} = buildingsAdapter.getSelectors((state) => state.buildings)

const selectRegionsActives = state => state.regions.actives
const selectTypesActives = state => state.building_types.actives
const selectPost = state=> state.post.entity

export const selectFilteredBuildings = createSelector(
    [
        (state) => selectAllBuildings(state), 
        selectRegionsActives, 
        selectTypesActives
    ],
    (buildings, regionsActives, buildingTypesActives) => 
        buildings
        .filter(building => regionsActives.some(region_id => region_id === building.location.region.id))
        .filter(building => buildingTypesActives.some(building_type_id => building_type_id === building.building_type.id))
        .sort((a,b) => a.building_type.id - b.building_type.id)
)

